import { Injectable } from '@angular/core';
import { NzIconService } from 'ng-zorro-antd/icon';
import {
  USER_ICON_LITERAL,
  OVERALL_ICON_LITERAL,
  TREND_ICON_LITERAL,
  REPORT_ICON_LITERAL,
  PLAN_ICON_LITERAL,
  MONITOR_ICON_LITERAL,
  ALARM_ICON_LITERAL,
  ORDER_ICON_LITERAL,
  EMERGENCY_ICON_LITERAL,
  STORAGE_ICON_LITERAL,
  VIDEO_ICON_LITERAL,
  SETTING_ICON_LITERAL,
  LOGGOUT_ICON_LITERAL,
  DEVICE_ICON_LITERAL,
  PROJECT_ICON_LITERAL,
  DEVICE_ONLINE_ICON_LITERAL,
  DEVICE_OFFLINE_ICON_LITERAL,
  PROJECT_DARK_ICON_LITERAL,
  ALARM_QUERY_ICON_LITERAL,
  DATA_QUERY_ICON_LITERAL,
  CONFIGURATION_ICON_LITERAL,
  PROJECT_LIST_ICON_LITERAL,
  ALARM_EMERGENCY_ICON,
  ALARM_NORMAL_ICON,
  LANG_SWITCH_EN_ICON,
  LANG_SWITCH_ZH_ICON
} from '../icons';

@Injectable({
  providedIn: 'root'
})
export class MmIconService {

  constructor(private iconService: NzIconService) {
    this.addMmIcons();

  }

  addMmIcons() {

    // this.iconService.addIconLiteral('mm:user', USER_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:overall', OVERALL_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:trend', TREND_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:report', REPORT_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:plan', PLAN_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:monitor', MONITOR_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:alarm', ALARM_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:order', ORDER_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:emergency', EMERGENCY_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:storage', STORAGE_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:video', VIDEO_ICON_LITERAL);
    this.iconService.addIconLiteral("mm:lang-switch-en", LANG_SWITCH_EN_ICON);
    this.iconService.addIconLiteral("mm:lang-switch-zh", LANG_SWITCH_ZH_ICON);

    // this.iconService.addIconLiteral('mm:setting', SETTING_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:logout', LOGGOUT_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:device', DEVICE_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:project', PROJECT_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:device-online', DEVICE_ONLINE_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:device-offline', DEVICE_OFFLINE_ICON_LITERAL);

    // this.iconService.addIconLiteral('mm:project-dark', PROJECT_DARK_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:alarm-query', ALARM_QUERY_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:data-query', DATA_QUERY_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:configuration', CONFIGURATION_ICON_LITERAL);
    // this.iconService.addIconLiteral('mm:project-list', PROJECT_LIST_ICON_LITERAL);

    // this.iconService.addIconLiteral('mm:alarm-emergency', ALARM_EMERGENCY_ICON);
    // this.iconService.addIconLiteral('mm:alarm-normal', ALARM_NORMAL_ICON);

  }
}
